export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_digital-promo-boost/artifacts/od7dgrrk_1783649706222.jpg";

export const CONTACT = {
  whatsapp: "+225 05 07 15 43 49",
  whatsappRaw: "2250507154349",
  infoline: "+225 01 02 27 35 37",
  infolineRaw: "2250102273537",
  orangeMoney: "+225 07 20 14 21 19",
  orangeMoneyRaw: "2250720142119",
  mtnMoney: "+225 05 07 15 43 49",
  mtnMoneyRaw: "2250507154349",
};

export const PAYMENTS = [
  { name: "Wave", color: "#1CA0FF", accent: "#0A6FBF", note: "Mobile Money" },
  {
    name: "Orange Money",
    color: "#FF7900",
    accent: "#B85400",
    note: "+225 07 20 14 21 19",
  },
  { name: "Moov Money", color: "#005C99", accent: "#4A8BC2", note: "Mobile Money" },
  {
    name: "MTN Money",
    color: "#FFCC00",
    accent: "#B38F00",
    note: "+225 05 07 15 43 49",
  },
];

// Item schema:
//   { id, title, desc, price, unit, popular, variants?: [{label, price, unit}] }
export const CATEGORIES = [
  {
    key: "tiktok",
    label: "TikTok",
    tag: "01 — Viralité",
    accent: "#FE2C55",
    emoji: "🎵",
    items: [
      {
        id: "tk-followers",
        title: "1 000 Abonnés TikTok",
        desc: "Grossissez votre communauté et déclenchez la preuve sociale.",
        variants: [
          { label: "Qualité Moyenne", price: "6 000", unit: "CFA" },
          { label: "Meilleure Qualité", price: "8 000", unit: "CFA" },
        ],
        popular: true,
      },
      {
        id: "tk-views",
        title: "10 000 Vues TikTok",
        desc: "Boostez la visibilité de vos vidéos et poussez l'algorithme.",
        price: "2 500",
        unit: "CFA",
      },
      {
        id: "tk-likes",
        title: "1 000 Likes TikTok",
        desc: "Renforcez l'engagement et la crédibilité de vos posts.",
        price: "1 000",
        unit: "CFA",
      },
      {
        id: "tk-live",
        title: "Booster Live · 200 spectateurs",
        desc: "Explosez votre live avec de vrais viewers en temps réel.",
        price: "5 000",
        unit: "CFA",
      },
      {
        id: "tk-monetize",
        title: "Création Page TikTok Monétisée",
        desc: "Un compte prêt à générer des revenus dès le premier jour.",
        price: "10 000",
        unit: "CFA",
      },
    ],
  },
  {
    key: "facebook",
    label: "Facebook",
    tag: "02 — Croissance",
    accent: "#1877F2",
    emoji: "📘",
    items: [
      {
        id: "fb-followers",
        title: "1 000 Abonnés Facebook",
        desc: "Une communauté qui grossit, une preuve sociale immédiate.",
        variants: [
          { label: "Qualité Moyenne", price: "3 500", unit: "CFA" },
          { label: "Meilleure Qualité", price: "7 000", unit: "CFA" },
        ],
        popular: true,
      },
      {
        id: "fb-views",
        title: "10 000 Vues Facebook",
        desc: "Boostez la portée de vos vidéos et de vos posts.",
        price: "2 500",
        unit: "CFA",
      },
      {
        id: "fb-likes",
        title: "1 000 Likes Facebook",
        desc: "Multipliez l'engagement sur vos publications.",
        price: "1 500",
        unit: "CFA",
      },
      {
        id: "fb-config",
        title: "Configuration Page Publicité + 500 abonnés",
        desc: "Page prête pour la pub. Élargissement + optimisation.",
        price: "8 000",
        unit: "CFA",
      },
      {
        id: "fb-page",
        title: "Page Vente Pro + 500 abonnés",
        desc: "Une vitrine professionnelle prête à convertir.",
        price: "10 000",
        unit: "CFA",
      },
      {
        id: "fb-ads",
        title: "Campagne Publicitaire — Ventes",
        desc: "Ads ciblées. 10 $ recommandé pour clientèle rapide.",
        price: "3 $ – 10 $",
        unit: "par jour",
      },
      {
        id: "fb-weekly",
        title: "Publicité en Ligne — Semaine",
        desc: "Boost hebdomadaire pour atteindre des milliers d'acheteurs.",
        price: "15 000",
        unit: "CFA / semaine",
      },
    ],
  },
  {
    key: "instagram",
    label: "Instagram",
    tag: "03 — Influence",
    accent: "#E4405F",
    emoji: "📸",
    items: [
      {
        id: "ig-followers",
        title: "1 000 Abonnés Instagram",
        desc: "Grandissez votre profil et transformez-le en marque.",
        variants: [
          { label: "Qualité Moyenne", price: "4 000", unit: "CFA" },
          { label: "Meilleure Qualité", price: "8 000", unit: "CFA" },
        ],
        popular: true,
      },
      {
        id: "ig-likes",
        title: "1 000 Likes Instagram",
        desc: "Renforcez l'engagement sur vos photos et Reels.",
        price: "2 000",
        unit: "CFA",
      },
      {
        id: "ig-views",
        title: "10 000 Vues Instagram",
        desc: "Boostez la portée de vos Reels et Stories.",
        price: "2 000",
        unit: "CFA",
      },
    ],
  },
  {
    key: "youtube",
    label: "YouTube",
    tag: "04 — Autorité",
    accent: "#FF0000",
    emoji: "🔴",
    items: [
      {
        id: "yt-followers",
        title: "1 000 Abonnés YouTube",
        desc: "Franchissez le cap de la monétisation avec de vrais abonnés.",
        variants: [
          { label: "Qualité Moyenne", price: "20 000", unit: "CFA" },
          { label: "Meilleure Qualité", price: "35 000", unit: "CFA" },
        ],
        popular: true,
      },
      {
        id: "yt-views",
        title: "1 000 Vues YouTube",
        desc: "Boostez le compteur de vues et l'algorithme.",
        price: "3 500",
        unit: "CFA",
      },
      {
        id: "yt-likes",
        title: "1 000 Likes YouTube",
        desc: "Renforcez l'engagement et la recommandation.",
        price: "3 000",
        unit: "CFA",
      },
    ],
  },
  {
    key: "certification",
    label: "Certification",
    tag: "05 — Confiance",
    accent: "#3B82F6",
    emoji: "✔",
    items: [
      {
        id: "cert-tiktok",
        title: "Certification TikTok",
        desc: "Le badge officiel pour asseoir votre autorité.",
        price: "Dès 12 000",
        unit: "CFA",
        popular: true,
      },
      {
        id: "cert-youtube",
        title: "Certification YouTube",
        desc: "Sceau officiel pour votre chaîne YouTube.",
        price: "Dès 12 000",
        unit: "CFA",
      },
      {
        id: "cert-instagram",
        title: "Certification Instagram",
        desc: "Le badge bleu tant convoité, en toute légalité.",
        price: "Dès 12 000",
        unit: "CFA",
      },
      {
        id: "cert-facebook",
        title: "Certification Facebook",
        desc: "Confiance instantanée pour votre page Facebook.",
        price: "Dès 12 000",
        unit: "CFA",
      },
      {
        id: "cert-telegram",
        title: "Certification Telegram",
        desc: "Sceau de vérification pour votre canal Telegram.",
        price: "Dès 12 000",
        unit: "CFA",
      },
      {
        id: "cert-snapchat",
        title: "Certification Snapchat",
        desc: "Vérification officielle Snapchat.",
        price: "Dès 12 000",
        unit: "CFA",
      },
    ],
  },
  {
    key: "monetisation",
    label: "Monétisation",
    tag: "06 — Revenus",
    accent: "#10B981",
    emoji: "💰",
    items: [
      {
        id: "mon-all",
        title: "Ancien compte Afrique — 5 réseaux",
        desc: "Monétisation clé en main : Facebook, YouTube, Instagram, Telegram, Snapchat. Ancien compte TikTok non éligible.",
        price: "30 000",
        unit: "CFA",
        popular: true,
      },
      {
        id: "mon-youtube",
        title: "YouTube — Monétisation",
        desc: "Activez la monétisation sur votre chaîne YouTube.",
        price: "15 000",
        unit: "CFA",
      },
      {
        id: "mon-instagram",
        title: "Instagram — Monétisation",
        desc: "Débloquez les revenus Instagram (Reels, Live, Badges).",
        price: "10 000",
        unit: "CFA",
      },
      {
        id: "mon-facebook",
        title: "Facebook — Monétisation",
        desc: "Activez les outils de monétisation de votre page.",
        price: "10 000",
        unit: "CFA",
      },
      {
        id: "mon-telegram",
        title: "Telegram — Monétisation",
        desc: "Transformez votre canal Telegram en revenus.",
        price: "10 000",
        unit: "CFA",
      },
      {
        id: "mon-snapchat",
        title: "Snapchat — Monétisation",
        desc: "Débloquez les Snap Stars et générez des revenus.",
        price: "10 000",
        unit: "CFA",
      },
    ],
  },
  {
    key: "design",
    label: "Design",
    tag: "07 — Marque",
    accent: "#D4AF37",
    emoji: "✦",
    items: [
      {
        id: "ds-logo",
        title: "Logo Professionnel",
        desc: "Une identité visuelle qui parle avant même que vous ne le fassiez.",
        price: "2 000",
        unit: "CFA",
      },
    ],
  },
];

export const BUDGET_GUIDE = [
  {
    price: "1 $",
    label: "Découverte",
    result: "Pas assez de commandes",
    level: 1,
    tone: "muted",
  },
  {
    price: "2 $",
    label: "Test",
    result: "Peu de commandes",
    level: 2,
    tone: "muted",
  },
  {
    price: "5 $",
    label: "Efficace",
    result: "Bons résultats",
    level: 3,
    tone: "silver",
  },
  {
    price: "10 $",
    label: "Recommandé",
    result: "Clientèle rapide, propre & rentable",
    level: 4,
    tone: "gold",
    recommended: true,
  },
];

export const STATS = [
  { label: "Clients accompagnés", value: "+1 200" },
  { label: "Abonnés générés", value: "500K+" },
  { label: "Campagnes lancées", value: "+3 400" },
  { label: "Pays desservis", value: "6" },
];

export const STEPS = [
  {
    n: "01",
    title: "Vous choisissez",
    desc: "Sélectionnez le pack qui correspond à votre objectif.",
  },
  {
    n: "02",
    title: "Vous nous contactez",
    desc: "WhatsApp, appel ou formulaire — tout est simple.",
  },
  {
    n: "03",
    title: "Paiement Mobile Money",
    desc: "Wave, Orange, Moov, MTN — payez en un clic sécurisé.",
  },
  {
    n: "04",
    title: "On booste, vous grandissez",
    desc: "Livraison rapide, résultats mesurables, suivi client.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Aïcha K.",
    role: "Boutique en ligne — Abidjan",
    quote:
      "En deux semaines, ma page Facebook a explosé. Les commandes tombent tous les jours.",
  },
  {
    name: "Serge M.",
    role: "Créateur TikTok",
    quote:
      "Le boost live a changé ma chaîne. Mes vidéos sont enfin vues par les bonnes personnes.",
  },
  {
    name: "Nadia B.",
    role: "Coach digital",
    quote:
      "Le logo est somptueux et les publicités convertissent. Service au top, prix imbattables.",
  },
];
